import { render } from "./InstallProduct.vue?vue&type=template&id=35a521ae"
import script from "./InstallProduct.vue?vue&type=script&lang=js"
export * from "./InstallProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__